export default __webpack_public_path__ + "static/media/ACGR SCORECARD for 2022.b3522f92.pdf";